import type {
	ClipboardEntry,
	ClipboardEntryType,
	ClipboardHandler,
	CopyContext,
	PasteContext,
} from "../types";
import { ElementsClipboardHandler } from "./elements";
import { KeyframesClipboardHandler } from "./keyframes";

export const clipboardCopyHandlers = [
	KeyframesClipboardHandler,
	ElementsClipboardHandler,
] as const satisfies readonly ClipboardHandler<ClipboardEntryType>[];

export function copyClipboardEntry({
	context,
}: {
	context: CopyContext;
}): ClipboardEntry | null {
	for (const handler of clipboardCopyHandlers) {
		if (!handler.canCopy(context)) {
			continue;
		}

		return handler.copy(context);
	}

	return null;
}

export function buildPasteClipboardCommand({
	entry,
	context,
}: {
	entry: ClipboardEntry;
	context: PasteContext;
}) {
	if (entry.type === "elements") {
		return ElementsClipboardHandler.paste({ entry, context });
	}
	return KeyframesClipboardHandler.paste({ entry, context });
}
